(ns ballot-scout-v2-frontend.voter-lookup.events
  (:require
   [ajax.edn :refer [edn-request-format edn-response-format]]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.db :as db]
   [ballot-scout-v2-frontend.disposition-manager.events :as e.disposition]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.exports.events :as e.exports]
   [ballot-scout-v2-frontend.import-manager.events :as e.import]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.util :as util]
   [ballot-scout-v2-frontend.voter-lookup.common :refer [ns-key default-search-state get-cached-args]]
   [clojure.set :as set]
   [day8.re-frame.async-flow-fx]
   [day8.re-frame.http-fx]
   [re-frame.core :as rf]))

(defn set-usps-returned [query-params]
  (if (= (:status query-params) "usps/returned")
    (assoc query-params :status "%/returned")
    query-params))

(defn prep-query-params-for-request [election-id query-params]
  (-> {:election-id election-id}
      (merge default-search-state)
      (merge query-params)
      (assoc :tester ["lt10-10-2022" "gt11-11-2022"])
      (set/rename-keys {:query "voter.search-query"})
      set-usps-returned))

(rf/reg-event-fx
 ::jurisdiction-fetch-ballots
 (fn [{:keys [db]} [_ {:keys [jurisdiction-id election-id query-params] :as args}]]
   (when (not= (get-cached-args db) args)
     {:db (-> db
              (assoc-in [ns-key :args] args)
              (assoc-in [ns-key :response] args))
      ::events/ajax {:method :get
                     :params (prep-query-params-for-request election-id query-params)
                     :uri (urls/ballots-for-jurisdiction jurisdiction-id)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::jurisdiction-fetch-ballots-success args]
                     :on-failure [::jurisdiction-fetch-ballots-failure args]}})))

(rf/reg-event-fx
 ::jurisdiction-fetch-ballots-success
 (fn [{:keys [db]} [_ args response]]
   {:db (assoc-in db [ns-key :response] response)
    :dispatch [::request-helpers/clear-failed-request [::jurisdiction-fetch-ballots args]]}))

(rf/reg-event-fx
 ::jurisdiction-fetch-ballots-failure
 (fn [_ [_ args response]]
   {:dispatch [::request-helpers/request-failed [::jurisdiction-fetch-ballots args] response]}))

(rf/reg-event-fx
 ::partner-fetch-ballots
 (fn [{:keys [db]} [_ {:keys [partner-id election-id query-params] :as args}]]
   (when (not= (get-cached-args db) args)
     {:db (-> db
              (assoc-in [ns-key :args] args)
              (assoc-in [ns-key :response] args))
      ::events/ajax {:method :get
                     :params (prep-query-params-for-request election-id query-params)
                     :uri (urls/ballots-for-partner partner-id)
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::partner-fetch-ballots-success args]
                     :on-failure [::partner-fetch-ballots-failure args]}})))

(rf/reg-event-fx
 ::partner-fetch-ballots-success
 (fn [{:keys [db]} [_ args response]]
   {:db (assoc-in db [ns-key :response] response)
    :dispatch [::request-helpers/clear-failed-request [::partner-fetch-ballots args]]}))

(rf/reg-event-fx
 ::partner-fetch-ballots-failure
 (fn [_ [_ args response]]
   {:dispatch [::request-helpers/request-failed [::partner-fetch-ballots args] response]}))

(rf/reg-event-fx
 ::fetch-ballot-history
 (fn [{:keys [db]} [_ {:ballot/keys [jurisdiction-id id] :as ballot-info}]]
   {:db (assoc db
               :ballot-history-response :loading
               :show-ballot-history ballot-info)
    ::events/ajax {:method :get
                   :uri (urls/ballot-history jurisdiction-id id)
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::fetch-ballot-history-success jurisdiction-id id]
                   :on-failure [::fetch-ballot-history-failure jurisdiction-id id]}}))

(rf/reg-event-fx
 ::fetch-ballot-history-success
 (fn [{:keys [db]} [_ jurisdiction-id ballot-id response]]
   {:db (assoc db :ballot-history-response response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-ballot-history jurisdiction-id ballot-id]]}))

(rf/reg-event-fx
 ::fetch-ballot-history-failure
 (fn [{:keys [db]} [_ jurisdiction-id ballot-id response]]
   {:db (assoc db :ballot-history-response nil)
    :dispatch [::request-helpers/request-failed [::fetch-ballot-history jurisdiction-id ballot-id] response]}))

(rf/reg-event-db
 ::set-searched?
 (fn [db [_ value]]
   (assoc-in db [ns-key :searched?] (boolean value))))

(rf/reg-event-db
 ::clear-voter-search-reponse
 (fn [db _]
   (update db ns-key #(dissoc % :response))))

(rf/reg-event-db
 ::clear-ballot-history
 (fn [db _]
   (dissoc db :ballot-history-response :show-ballot-history)))

(rf/reg-event-fx
 ::create-export-for-jurisdiction
 (fn [_ [_ jurisdiction-id election-id query-params mimetype]]
   {:dispatch [::e.exports/create-export-for-jurisdiction
               ns-key
               (urls/ballot-export-for-jurisdiction jurisdiction-id)
               jurisdiction-id
               election-id
               (prep-query-params-for-request election-id query-params)
               mimetype]}))

(rf/reg-event-fx
 ::create-export-for-partner
 (fn [_ [_ partner-id election-id query-params mimetype]]
   {:dispatch [::e.exports/create-export-for-partner
               ns-key
               (urls/ballot-export-for-partner partner-id)
               partner-id
               election-id
               (prep-query-params-for-request election-id query-params)
               mimetype]}))

(rf/reg-event-fx
 ::clear-export-state
 (fn [_ [_]]
   {:dispatch [::e.exports/clear-export-state ns-key]}))

(rf/reg-event-fx
 ::jurisdiction-trigger-new-search-for-route
 (fn [{:keys [db]} [_ route]]
   (let [{:keys [partner-slug jurisdiction-slug election-slug]} (:path-params route)
         partner (db/partner-by-slug db partner-slug)
         jurisdiction (db/jurisdiction-by-slug db jurisdiction-slug)
         election (db/election-by-slug-and-partner-id db election-slug (:partner/id partner))
         query-params (-> route :query-params not-empty)]
     {:dispatch [::jurisdiction-fetch-ballots {:jurisdiction-id (:jurisdiction/id jurisdiction)
                                               :election-id (:election/id election)
                                               :query-params query-params}]})))

(defn fetch-disposition-for-route? [db route]
  (let [disposition-id (get-in route [:query-params :disposition-id])
        disposition (db/disposition-by-id db (util/->int disposition-id))]
    (and disposition-id (not disposition))))

(defn fetch-import-for-route? [db route]
  (let [import-id (get-in route [:query-params :import-id])
        import (db/import-by-id db (util/->int import-id))]
    (and import-id (not import))))

(rf/reg-event-fx
 ::jurisdiction-voter-lookup-navigate
 (fn [{:keys [db]} [_ route]]
   (let [partner-slug (get-in route [:path-params :partner-slug])
         jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])
         partner (db/partner-by-slug db partner-slug)
         election (db/election-by-slug-and-partner-id db
                                                      (get-in route [:path-params :election-slug])
                                                      (:partner/id partner))
         {:keys [import-id disposition-id]} (:query-params route)
         fetch-import? (fetch-import-for-route? db route)
         fetch-disposition? (fetch-disposition-for-route? db route)]
     (if (not-empty election)
       ;; if election exists then the partner / juri / election records have already been
       ;; fetched. So we only need to trigger a new search here
       {:dispatch-n [[::jurisdiction-trigger-new-search-for-route route]
                     (when fetch-import?
                       [::e.import/fetch-import import-id])
                     (when fetch-disposition?
                       [::e.disposition/fetch-disposition disposition-id])]}
       ;; else
       {:dispatch-n [[::events/fetch-partner partner-slug]
                     [::events/fetch-jurisdiction jurisdiction-slug]
                     (when fetch-import?
                       [::e.import/fetch-import import-id])
                     (when fetch-disposition?
                       [::e.disposition/fetch-disposition disposition-id])]
        :async-flow {:rules [{:when :seen?
                              :events ::events/fetch-jurisdiction-success
                              :dispatch [::events/fetch-elections-for-jurisdiction jurisdiction-slug]}
                             {:when :seen?
                              :events [::events/fetch-elections-for-jurisdiction-success ::events/fetch-partner-success]
                              :dispatch [::jurisdiction-trigger-new-search-for-route route]
                              :halt? true}]}}))))

(rf/reg-event-fx
 ::partner-trigger-new-search-for-route
 (fn [{:keys [db]} [_ route]]
   (let [{:keys [partner-slug election-slug]} (:path-params route)
         partner (db/partner-by-slug db partner-slug)
         election (db/election-by-slug-and-partner-id db election-slug (:partner/id partner))
         query-params (-> route :query-params not-empty)]
     {:dispatch [::partner-fetch-ballots {:partner-id (:partner/id partner)
                                          :election-id (:election/id election)
                                          :query-params query-params}]})))

(rf/reg-event-fx
 ::partner-voter-lookup-navigate
 (fn [{:keys [db]} [_ route]]
   (let [partner-slug (get-in route [:path-params :partner-slug])
         partner (db/partner-by-slug db (get-in route [:path-params :partner-slug]))
         election (db/election-by-slug-and-partner-id db
                                                      (get-in route [:path-params :election-slug])
                                                      (:partner/id partner))
         {:keys [import-id disposition-id]} (:query-params route)
         fetch-import? (fetch-import-for-route? db route)
         fetch-disposition? (fetch-disposition-for-route? db route)]
     (if (not-empty election)
       ;; if election exists then the partner / juri / election records have already been
       ;; fetched. So we only need to trigger a new search here
       {:dispatch-n [[::partner-trigger-new-search-for-route route]
                     (when fetch-import?
                       [::e.import/fetch-import import-id])
                     (when fetch-disposition?
                       [::e.disposition/fetch-disposition disposition-id])]}
       ;; else
       {:dispatch-n [[::events/fetch-partner partner-slug]
                     (when fetch-import?
                       [::e.import/fetch-import import-id])
                     (when fetch-disposition?
                       [::e.disposition/fetch-disposition disposition-id])]
        :async-flow {:rules [{:when :seen?
                              :events [::events/fetch-partner-success]
                              :dispatch [::partner-trigger-new-search-for-route route]
                              :halt? true}]}}))))
